<template>
    <b-container fluid>
        <header-buttons
                :buttons="headerButtons"
                @onNewMatch="newMatch"
        ></header-buttons>
        <admin-matches-table
                @onShow="show"></admin-matches-table>
        <modal-update-password
                :showModal="showModalUpdatePassword"
                @updateShowModal="(value) => { showModalUpdatePassword = value }"></modal-update-password>
    </b-container>
</template>

<script>
    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
    import AdminMatchesTable from "../components/AdminMatchesTable";
    import {mapGetters, mapActions, mapMutations} from 'vuex';
    import ModalUpdatePassword from "../../../components/modal-update-password/ModalUpdatePassword";

    export default {
        name: "AdminMatchesListView",
        components: {ModalUpdatePassword, AdminMatchesTable, HeaderButtons},
        data() {
            return {
                headerButtons: [
                    {
                        label: 'Nuova Partita',
                        onClick: 'onNewMatch',
                    }
                ],
                showModalUpdatePassword: false
            }
        },
        computed: {
            ...mapGetters([
                'currentUser'
            ]),
        },
        mounted() {
          this.adminMatchesGetSectors().then().catch();

            this.$root.$on('bv::modal::hide', () => {
                this.showModalUpdatePassword = false;
            });

            if (this.currentUser.tempPassword) {
                this.showModalUpdatePassword = true;
            }

        },
        methods: {
            ...mapActions({
                adminMatchesShow: 'adminMatchesShow',
                adminMatchesGetSectors: 'adminMatchesGetSectors',
            }),

            ...mapMutations([
                'adminMatchesSetCurrentMatch'
            ]),

            newMatch: function() {
                this.adminMatchesSetCurrentMatch({});
                this.$router.push({name : 'admin.matches.new'})
            },
            show: function (match) {
                this.adminMatchesShow(match)
                    .then((resp) => {
                        this.$router.push({name: 'admin.matches.show', params: {id: resp.id}});
                    }).catch(() => {
                    this.$bvToast.toast('Partita non trovata', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                });
            }
        }
    }
</script>

<style scoped>

</style>
